module.exports = __webpack_public_path__ + "static/notification-5672f9d168c1ade44eab593299aca91c.svg";